import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';
import getFormattedValues, { formatReceived } from 'utils/formatValues';

export const baseURI = '/empresas/arrendamientos/';

/**
 * GET Arrendamientos
 * @param {Object} params
 * @returns {Promise<Array<Object>>}
 */
export const getArrendamientos = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    const output = { ...response.data, results: formatReceived(response.data.results) };
    return output;
  } catch (err) {
    onError(err);
    return { results: [] };
  }
};

/**
 * GET Arrendamiento
 * @param {number} id
 * @returns {Promise<Object>}
 */
export const getArrendamiento = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Arrendamiento
  * @param {Object} values
 * @returns {Promise<Object>}
 */
export const postArrendamiento = async (values) => {
  try {
    const response = await API.post(baseURI, getFormattedValues(values));
    onSuccess(response, 'Agregado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Arrendamiento
 * @param {number} id
 * @param {Object} values
 * @returns {Promise<Object>}
 */
export const patchArrendamiento = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, getFormattedValues(values));
    onSuccess(response, 'Editado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Arrendamiento
 * @param {number} id
 * @returns {Promise<Object>}
 */
export const deleteArrendamiento = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 *  GET Horarios Arrendamiento
 * @param {number} id
 * @returns Promise<Array<Object>>
 */
export const getHorariosArrendamiento = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}/horarios/`);
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Arrendamiento para la caja
 * @param {object} params
 * @returns {Promise<Array<Object>>}
 */
export const getArrendamientoCaja = async (params = null) => {
  try {
    const response = await API.get('/empresas/arrendamiento-caja/', { params });
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return [];
  }
};
